export default {
  publicApiURL: process.env.REACT_APP_PUBLIC_API,
};
